import { render, staticRenderFns } from "./ticketSharing.vue?vue&type=template&id=99364594&scoped=true&"
import script from "./ticketSharing.vue?vue&type=script&lang=js&"
export * from "./ticketSharing.vue?vue&type=script&lang=js&"
import style0 from "./ticketSharing.vue?vue&type=style&index=0&id=99364594&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99364594",
  null
  
)

export default component.exports